const REMIXICON_ID = "ck-remixicon-css";

/** Load remixicon after first paint so it does not block LCP. */
export function loadRemixicon() {
  if (typeof document === "undefined" || document.getElementById(REMIXICON_ID)) {
    return;
  }
  const link = document.createElement("link");
  link.id = REMIXICON_ID;
  link.rel = "stylesheet";
  link.href =
    "https://cdn.jsdelivr.net/npm/remixicon@4.0.0/fonts/remixicon.css";
  link.crossOrigin = "anonymous";
  document.head.appendChild(link);
}
